import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { favoriteActions } from "../../../../../store/favorite-slice"

const Resort = (props) => {
       const { type, name } = props
       const { resort } = useFilter()
       
       let filteredFavorites = useSelector((state) => state.favorite.filteredFavorites)
       let favorites=useSelector(state=>state.favorite.favorites)
       let dispatch = useDispatch()
   
       return <Fragment>
           <label>{name}</label><select className="mb-2"
               onChange={(event) => {
                   let value = event.target.value
   
                   switch (value) {
                       case 'ASC':
                           dispatch(favoriteActions.setFilteredItems(resort(filteredFavorites??favorites, type, 'ASC')))
                           break
   
                       case 'DESC':
                           dispatch(favoriteActions.setFilteredItems(resort(filteredFavorites??favorites, type, 'DESC')))
                           break
                       default:
                           break
                   }
   
               }}
   
           >
               <option value='' >Sort</option>
               <option value='ASC' >Ascending</option>
               <option value='DESC' >Descending</option>
           </select>
       </Fragment>
}

export default Resort
